// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  assetId: __t.string().primaryKey().name("asset_id"),
  orgId: __t.string().name("org_id"),
  scopeId: __t.string().name("scope_id"),
  status: __t.string(),
  round: __t.u32(),
  requestedByUserId: __t.string().name("requested_by_user_id"),
  requestedByName: __t.string().name("requested_by_name"),
  updatedAt: __t.timestamp().name("updated_at"),
});
